export type Period = 'day' | 'week' | 'month' | 'quarter' | 'year';
